<template>
    <div class="main">

        <c-panel>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <label>Relatórios</label>
                    <el-select v-model="tipo">
                        <el-option :key="1" label="GERAL" :value="1"></el-option>
                    </el-select>
                </el-col>
            </el-row>
        </c-panel>

        <div class="u-mt-10">
            <geral v-if="tipo == 1"></geral>
        </div>

        
    </div>
</template>
<script>

import geral from "./geral"

export default {
    data: () => ({
        tipo: 1        
    }),
    mounted () {

    },
    methods: {     
        text(){

            
        }
    },
    components:{ geral }
}
</script>